<template>
  <b-container id="main" class="d-flex px-2 py-0 m-0" fluid>
    <div class="w-100 flex-grow-1">
      <template v-if="$route.path === '/account'">
        <AccountMgmt />
      </template>
      <template v-if="$route.path === '/dietitian'">
        <DietitianMgmt />
      </template>
      <template v-if="$route.path === '/dietitian/clients'">
        <DietitianClients />
      </template>
      <template v-if="$route.path === '/file'">
        <FileMgmt />
      </template>
      <template v-if="$route.path === '/file/upload'">
        <FileUpload />
      </template>
      <template v-if="$route.path === '/file/edit'">
        <FileEdit />
      </template>
      <template v-if="$route.path === '/group'">
        <GroupMgmt />
      </template>
      <template v-if="$route.path === '/group/users'">
        <GroupUsers />
      </template>
      <template v-if="$route.path === '/user'">
        <UserMgmt />
      </template>
      <template v-if="$route.path === '/user/account'">
        <UserAccountMgmt />
      </template>
      <template v-if="$route.path === '/user/survey'">
        <UserAccountSurvey />
      </template>
      <template v-if="$route.path === '/shared-content'">
        <SharedContent />
      </template>
      <template v-if="$route.path === '/user/add' || $route.path === '/user/parents' || $route.path === '/user/payment'">
        <AddUser />
      </template>
      <template v-if="$route.path.includes('/bulk')">
        <BulkUpload />
      </template>
      <template v-if="$route.path === '/group/add'">
        <CreateGroupForm />
      </template>
      <template v-if="$route.path === '/group/edit'">
        <EditGroupForm />
      </template>
      <template >
        <Messaging v-if="$route.path ==='/messages'" />
      </template>
      <template >
        <ManageSubscription v-if="$route.path ==='/subscriptions'" />
      </template>
      <template >
        <EditSubscription v-if="$route.path ==='/subscriptions/edit'" />
      </template>
      <template v-if="$route.path === '/add-parent'">
        <ParentFormContainer :forClient="false"/>
      </template>
    </div>
  </b-container>
</template>

<script>
import AccountMgmt from '../../Pages/AccountMgmt/AccountMgmt'
import DietitianMgmt from '../../Pages/DietitianMgmt/DietitianMgmt'
import DietitianClients from '../../Pages/DietitianMgmt/DietitianClients'
import FileMgmt from '../../Pages/FileMgmt/FileMgmt'
import FileEdit from '../../Pages/FileMgmt/FileEdit'
import FileUpload from '../../Pages/FileMgmt/FileUpload'
import GroupMgmt from '../../Pages/GroupMgmt/GroupMgmt'
import GroupUsers from '../../Pages/GroupMgmt/GroupUsers'
import UserMgmt from '../../Pages/UserMgmt/UserMgmt'
import UserAccountMgmt from '../../Pages/UserMgmt/UserAccountMgmt'
import SharedContent from '../../Pages/SharedContent/SharedContent'
import AddUser from '../../Pages/AddUser/AddUser'
import BulkUpload from '../../Pages/BulkUpload/BulkUpload'
import CreateGroupForm from '../Forms/CreateGroupForm'
import EditGroupForm from '../Forms/EditGroupForm'
import Messaging from '../../Pages/Messaging/Messaging'
import ManageSubscription from '../../Pages/ManageSubscription/ManageSubscription'
import EditSubscription from '../../Pages/ManageSubscription/EditSubscription'
import ParentFormContainer from '../Forms/ParentFormContainer'

export default {
  name: 'MainContent',
  components: {
    AccountMgmt,
    DietitianMgmt,
    DietitianClients,
    FileMgmt,
    FileUpload,
    FileEdit,
    GroupMgmt,
    UserMgmt,
    SharedContent,
    AddUser,
    BulkUpload,
    UserAccountMgmt,
    CreateGroupForm,
    EditGroupForm,
    GroupUsers,
    Messaging,
    ManageSubscription,
    EditSubscription,
    ParentFormContainer
  },
  data() {
    return {
      title: 'Admin'
    }
  }
}
</script>

<style scoped>
#main {
  min-height: calc(100% - 60px);
}

@media (min-width: 1200px) {
  #main {
    min-height: calc(100% - 103px);
  }
}
</style>



// WEBPACK FOOTER //
// src/app/components/Layout/MainContent.vue?3a6ac111